import { OrderProduct, OrderReturnStatus, OrderType } from '../../../clients/quipli-service/order/order';
import classNames from 'classnames';
import './order-product-status-badge.scss';

export const OrderProductStatusBadge = ({ orderProduct }: { orderProduct: OrderProduct }) => {
  let label;

  if (orderProduct.type === OrderType.Rental) {
    switch (orderProduct.status) {
      case OrderReturnStatus.Complete:
        label = 'Returned';
        break;
      case OrderReturnStatus.OffRent:
        label = 'Off Rent';
        break;
      case OrderReturnStatus.OnRent:
        label = 'On Rent';
        break;
      default:
        label = 'Not Started';
    }
  } else {
    label = 'Sale';
  }
  return (
    <div
      className={classNames(
        'w-fit p-1 px-2 rounded-2xl text-white text-xs op-status',
        'op-status-',
        label.toLowerCase().replaceAll(' ', '-'),
      )}
    >
      {label}
    </div>
  );
};
